/* Pure Cartel — homepage interactions */
(function () {
  "use strict";

  /* ---------- testimonial carousel with dots ---------- */
  const track = document.getElementById("homeTrack");
  const dotsWrap = document.getElementById("homeDots");
  const cards = Array.from(track.querySelectorAll(".review"));

  cards.forEach((_, i) => {
    const dot = document.createElement("button");
    dot.setAttribute("aria-label", "Go to testimonial " + (i + 1));
    if (i === 0) dot.classList.add("is-active");
    dot.addEventListener("click", () => {
      track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: "smooth" });
    });
    dotsWrap.appendChild(dot);
  });

  const dots = Array.from(dotsWrap.children);
  track.addEventListener("scroll", () => {
    const cardWidth = cards[0].getBoundingClientRect().width + 16;
    const index = Math.min(cards.length - 1, Math.round(track.scrollLeft / cardWidth));
    dots.forEach((d, i) => d.classList.toggle("is-active", i === index));
  }, { passive: true });
})();
